// src/modules/app-views/toolbox/pages/Init/components/tableColumns/nameColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function nameColumn(buildColumnProps, options = {}) {
  const {
    key = 'name',
    title = 'tool_name',
    dataIndex = 'name',
    width,
    columnProps = { sort: true, search: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    className: 'text-truncate',
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => (
      <div className="d-flex" style={{ width }}>
        <span className="font-weight-semibold">{r?.name || '\u2014'}</span>
      </div>
    ),
  };
}

export default nameColumn;
